import Styles from './BrandKitWidget.module.scss'
import { Header } from './Header'
import { Preview } from './Preview'
import { BrandKitWidgetProps } from './Types'
import { BrandKitLogo } from 'screens/BrandKit/BrandKitLogo/BrandKitLogo'
import { Text } from 'blaze-ui/Text/Text'
import { pluralize } from 'utils'
import { CSSProperties } from 'react'
import cx from 'classnames'
import { AlertTriangle } from 'blaze-ui/icons'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

const BrandKitWidget = ({ brandKit }: BrandKitWidgetProps) => {
  const { external_integrations: externalIntegrations, websites } = brandKit
  const isMigrationLive = useFlipperFlag('brand_kit_migration')
  const isIncomplete = brandKit.incomplete && websites.length < 1 && isMigrationLive

  return (
    <div
      className={cx(Styles.widget, { [Styles.incomplete]: isIncomplete })}
      style={
        {
          '--primary-color': brandKit?.brand_visual_kit?.primary_color_palette?.colors[0]?.hex,
        } as CSSProperties
      }
      data-testid="brand-kit-widget"
    >
      <div className={Styles.preview}>
        <Preview brandKit={brandKit} />
      </div>
      <div className={Styles.textAndAvatar}>
        <div className={Styles.avatar}>
          <BrandKitLogo brandKit={brandKit} />
        </div>
        <div className={Styles.textContainer}>
          <div className={Styles.text}>
            <Header brandKit={brandKit} />
            {!isIncomplete && (
              <Text variant="label" color="var(--dark-40)">
                {externalIntegrations.length} {pluralize('Account', externalIntegrations.length)} linked
              </Text>
            )}
            {isIncomplete && (
              <Text variant="metadata" color="#9A7900">
                Website not connected
              </Text>
            )}
          </div>
          {isIncomplete && (
            <div className={Styles.alert}>
              <AlertTriangle color="var(--light-100)" size={24} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export { BrandKitWidget }
